import { Link } from "wouter";
import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";

export function FinalCTA() {
  return (
    <section className="bg-white px-5 py-24 sm:px-8">
      <Reveal className="mx-auto max-w-6xl">
        <div className="relative overflow-hidden rounded-[2.5rem] bg-gradient-to-br from-blue-700 via-blue-600 to-sky-500 px-8 py-16 text-center shadow-2xl shadow-blue-900/20 sm:px-16 sm:py-20">
          <div className="pointer-events-none absolute -right-10 -top-10 h-56 w-56 rounded-full bg-white/10 blur-2xl" />
          <div className="pointer-events-none absolute -bottom-16 -left-10 h-56 w-56 rounded-full bg-white/10 blur-2xl" />

          <h2 className="relative mx-auto max-w-2xl text-3xl font-bold leading-tight tracking-tight text-white sm:text-4xl">
            Spend More Time With Patients. Less Time Charting.
          </h2>
          <p className="relative mx-auto mt-5 max-w-xl text-lg text-blue-50">
            Join the next generation of clinicians adopting healthcare AI documentation to
            simplify every patient visit.
          </p>
          <div className="relative mt-9 flex justify-center">
            <Link
              href="/sign-up"
              data-testid="button-final-cta"
              className="inline-flex items-center justify-center gap-2 rounded-full bg-white px-8 py-3.5 text-base font-semibold text-blue-700 shadow-lg transition-transform hover:scale-[1.02]"
            >
              Start Your Free Trial
              <ArrowRight className="h-4 w-4" />
            </Link>
          </div>
        </div>
      </Reveal>
    </section>
  );
}
